<template>
  <div class="d-flex flex-column full-width" v-clickout="handleOutsideClick">
    <div class="align-center d-flex">
      <div class="full-width">
        <v-text-field
          autocomplete="off"
          class="search-box-radius e2e-search-box"
          background-color="#ffffff"
          hide-details="true"
          type="search"
          label="Search for products"
          :value="searchText"
          @input="updateSearchText"
          outlined
          dense
        ></v-text-field>
      </div>
      <div>
        <v-btn
          small
          depressed
          class="search-button-radius e2e-search-button"
          color="primary"
          height="40"
        >
          <img alt="search" src="@/assets/banner/ic-search.svg" height="26" width="22" />
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import debounce from "lodash.debounce";

// let handleClickOut;
export default {
  name: "Search",
  computed: {
    ...mapState({
      products: state => state.search.products,
      isDetailsOpened: (state) => state.product.dialog.details,
      searchText: state => state.search.text
    })
  },
  data() {
    return {
      typing: false
    };
  },
  directives: {
    clickout: {
      bind: function(el, binding, vnode) {
        el.clickOutsideEvent = function(event) {
          const { target } = event;
          const parentWithKeepSearchId = target.closest("#keep-search");
          if (parentWithKeepSearchId) {
            return;
          }
          if (!(el == target || el.contains(target))) {
            vnode.context[binding.expression]();
          }
        };
        document.body.addEventListener("click", el.clickOutsideEvent);
      },
      unbind: function(el) {
        document.body.removeEventListener("click", el.clickOutsideEvent);
      }
    }
  },
  methods: {
    handleOutsideClick() {
      if (this.isDetailsOpened) {
        return;
      }
      this.$store.state.search.products && this.$store.commit("search/RESET");
    },
    updateSearchText(searchText) {
      this.typing = true;
      this.$store.commit("search/UPDATE_TEXT", searchText);
    }
  },
  watch: {
    searchText: debounce(function() {
      this.typing = false;
    }, 1000),
    typing: async function() {
      this.$store.commit("search/CLEAR_PRODUCTS");
      if (!this.typing && this.searchText.length > 2) {
        await this.$store.dispatch("search/fetch");
      }
    }
  }
};
</script>

<style scoped>
.search-button-radius {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  border-bottom-right-radius: 10px;
  border-top-right-radius: 10px;
}
.search-box-radius {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: 10px;
  border-top-left-radius: 10px;
}
</style>
